var exports = {
  "iE": "x31de4314--dc3fb1--wrapper",
  "r8": "x31de4314--dc3fb1--wrapper--empty-state",
  "DD": "x31de4314--dc3fb1--title",
  "mW": "x31de4314--dc3fb1--moreSuggestionsButtonContainer",
};

module.exports = exports;
